import * as React from 'react'
import Trash from '../../../../../../../assets/icons_new/DeleteColor.svg'
import AssignToDiffrentDriverColor from '../../../../../../../assets/icons_new/AssignToDiffrentDriverColor.svg'
import TableActionBar from '@/modules/drivers/shared/tableItems/TableActionBar'
import { TableActionButtonInterface } from '@/modules/drivers/types'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useTable } from '@/modules/drivers/context/TableContext'
import AssignCardToDriverModal from '@/modules/drivers/modals/driverCards/AssignCardToDriverModal'
import useFormatDate from '@/modules/drivers/hooks/useFormatDate'
import { DriverCardModel } from '@/app/models'

const DriverCardsActions = ({
  companyId,
  driverId,
  cards,
}: {
  companyId: string
  driverId: number
  cards: DriverCardModel[]
}) => {
  const { t } = useLocalize()
  const { formatDateWithTime } = useFormatDate()
  const { selectedGroup, resetAll } = useTable()
  const [isAssignModalOpen, setIsAssignModalOpen] = React.useState(false)
  const selectedCardId = Number(selectedGroup?.ids?.[0])
  const selectedCard = cards.find((c) => c.driverCardId === selectedCardId)

  const actions: TableActionButtonInterface[] = [
    {
      icon: AssignToDiffrentDriverColor,
      action: () => setIsAssignModalOpen(true),
      tooltip: t('driverModule.assign-to-another-driver'),
    },
    {
      icon: Trash,
      action: () => console.log(),
      tooltip: t('common.delete'),
    },
  ]
  return (
    <>
      <TableActionBar actions={actions}>
        {selectedCard && (
          <div className="tw-flex tw-flex-wrap tw-justify-end tw-gap-x-6 tw-text-sm tw-text-base-content/70">
            <span>
              {t('auditFields.created-date')}:{' '}
              <span className="tw-font-medium tw-text-base-content">
                {formatDateWithTime(selectedCard.created)}
              </span>
              {selectedCard.createdBy && ` (${selectedCard.createdBy})`}
            </span>
            <span>
              {t('auditFields.modified-date')}:{' '}
              <span className="tw-font-medium tw-text-base-content">
                {formatDateWithTime(selectedCard.modified)}
              </span>
              {selectedCard.modifiedBy && ` (${selectedCard.modifiedBy})`}
            </span>
          </div>
        )}
      </TableActionBar>
      {isAssignModalOpen && !!selectedCardId && (
        <AssignCardToDriverModal
          companyId={companyId}
          driverId={driverId}
          driverCardId={selectedCardId}
          close={() => setIsAssignModalOpen(false)}
          onAssigned={resetAll}
        />
      )}
    </>
  )
}

export default DriverCardsActions
